// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import TitleTypography from "@hardwoods/App/Components/Common/TitleTypography";
import translate from "@insite/client-framework/Translate";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import * as React from "react";
import { css } from "styled-components";

// Add style to Typography title and link
export interface CardListHeadingStyles {
    titleText?: TypographyPresentationProps;
    titleGridItem?: GridItemProps;
    linkGridItem?: GridItemProps;
    viewAllLink?: TypographyPresentationProps;
}

export const cardListHeadingStyles: CardListHeadingStyles = {
    titleGridItem: {
        css: css`
            justify-content: flex-start;
            align-items: baseline;
        `,
    },
    titleText: {
        variant: "h2",
        size: 38,
        lineHeight: "36px",
        css: css`
            margin-bottom: 0;
        `,
    },
    viewAllLink: {
        color: "secondary.main",
        css: css`
            margin-left: 30px;
        `,
    },
};

const styles = cardListHeadingStyles;

interface OwnProps {
    // XNG-Changes: Update Structure
    // heading: string;
    primaryTitle?: string;
    secondaryTitle?: string;
    viewAllUrl?: string;
}

const CardListHeading: React.FunctionComponent<OwnProps> = ({ primaryTitle, secondaryTitle, viewAllUrl }) => {
    return (
        <GridItem width={12}>
            <GridContainer>
                <GridItem width={12} {...styles.titleGridItem}>
                    <TitleTypography
                        primaryTitle={primaryTitle}
                        secondaryTitle={secondaryTitle}
                        {...styles.titleText}
                    />
                    {viewAllUrl && (
                        <Link
                            href={viewAllUrl}
                            typographyProps={{ size: 15 }}
                            {...styles.viewAllLink}
                            className="view-all-link"
                            data-test-selector="cardListHeadingViewAllLink"
                        >
                            {translate("View All")}
                        </Link>
                    )}
                </GridItem>
            </GridContainer>
        </GridItem>
    );
};

export default CardListHeading;
